angular
  .module('common', [
    'common.sw'
  ]);